<template lang="html">
  <div class="_infoheader" :class="`${rfqData ? rfqData.service_head === 'AIR' ? 'global__bc_purple' : rfqData.service_head === 'LAND' ? 'global__bc_deepgreen' : 'global__bc_blue' : 'global__bc_blue'}`">
    <div class="row m-0" v-if="isLoading">
      <half-circle-spinner
        :animation-duration="750"
        :size="100"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div class="row m-0" v-if="isError">
    </div>
    <div class="row m-0"
      v-if="rfqData">
      <div style="cursor: pointer; z-index: 50;" class="_infoheader_back d-flex align-items-center" @click="goBack">
          <img src="@/assets/image/icon/arrow-back-full-yellow.svg" alt="">
          <span style="color: #FFFF00;" >Back</span>
      </div>
      <div class="col-md-5 pl-3 _infoheader__left">
        <b class="d-flex">Booking Form</b>
        <div class="row _infoheader__leftCol--texttop">
          <img :src="getImageShipment(rfqData.service_head)">
          <span class="__text"> {{rfqData.city_from}} [{{ rfqData.cityf }}] to {{rfqData.city_to}} [{{ rfqData.cityt }}]</span>
        </div>
        <div v-if="rfqData.service_head !== 'LAND'" style="margin-left: 48px; margin-top: 5px; font-size: 14px;" class="col-md" >{{ getFreigtMode(rfqData.service_head) }} / {{getShipmentType(rfqData.shipment_type.replace(/SEA/g,''))}}</div>
        <div v-else style="margin-left: 48px; margin-top: 5px; font-size: 14px;" class="col-md" >{{ getFreigtMode(rfqData.service_head) }}</div>
        <!-- <p class="_infoheader__leftCol--textmiddle"><span class="__ft">{{ rfqData.service_head }} {{ rfqData.shipment_type }}</span> <span class="__type" v-if="rfqData.service_head === 'OCEAN'">| {{ rfqData.service_sub_type }}</span></p> -->
        <p class="_infoheader__leftCol--textbottom" v-if="rfqData.status === 3" > Canceled </p>
        <p class="_infoheader__leftCol--textbottom" v-else> {{ statusBid }}</p>
      </div>
      <template v-if="rfqData.service_head !== 'LAND'">
        <div class="col-md _infoheader__middle">
          <!-- <div class="row">
            <div class="col-md-5 pr-0">Freight Mode</div>
            <div class="col-md">: {{ getFreigtMode(rfqData.service_head) }}</div>
          </div>
          <div class="row">
            <div class="col-md-5 pr-0">Shipment Type</div>
            <div class="col-md"> :  {{getShipmentType(rfqData.shipment_type.replace(/SEA/g,''))}} </div>
          </div> -->
          <div class="row">
            <!-- <div class="col-md-5 pr-0">Container Type</div> -->
            <!-- <div class="col-md">: {{ rfqData.service_sub_type  }}</div> -->
            <div class="col-md-6 pr-0">Shipment Date</div>
            <div class="col-md">: {{ getDate(rfqData.cargo_readynes_date) }}</div>
          </div>
          <!-- <div class="row" v-if="rfqData.shipment_type && rfqData.shipment_type.includes('FCL')">
            <div class="col-md-5 pr-0">Temperature</div>
            <div class="col-md">: {{ rfqData.service_sub_type === 'Reefer' ? rfqData.temperature + ' &#8451;' : '-' }}</div>
          </div>
          <div class="row" v-if="rfqData.shipment_type && rfqData.shipment_type.includes('FCL') && rfqData.container_option">
            <div class="col-md-5 pr-0">Container Option</div>
            <div class="col-md">: {{ getContainerOption(rfqData.container_option) }}</div>
          </div> -->
          <div class="row">
            <div class="col-md-6 pr-0">Quantity</div>
            <div class="col-md">: {{ parseInt(rfqData.estimatedqty) }}</div>
            <!-- <div class="col-md">: {{ parseInt(rfqData.estimatedqty) }} {{ rfqData.satuan }}</div> -->
          </div>
          <!-- di hide karena Container Packaging type nya bisa lebih dari 1  -->
          <!-- <div class="row">
            <div class="col-md-6 pr-0">Container Packaging Type</div>
            <div class="col-md">: {{ rfqData.service_sub_type  }}</div>
          </div> -->
          <div class="row" v-if="(rfqData.shipment_type === 'AIRCARGO' || rfqData.shipment_type === 'AIRCOURIER')">
            <div class="col-md-6 pr-0">Volume</div>
            <div class="col-md">: {{ rfqData.estimateddimension }} Volumetric</div>
          </div>
          <div class="row" v-if="(rfqData.shipment_type === 'SEALCL')">
            <div class="col-md-6 pr-0">Volume</div>
            <div class="col-md">: {{ rfqData.estimateddimension }} cbm</div>
          </div>
          <!-- <div class="row" v-if="(rfqData.shipment_type === 'AIRCARGO' || rfqData.shipment_type === 'AIRCOURIER' || rfqData.shipment_type === 'SEALCL')">
            <div class="col-md-6 pr-0">Dimension</div>
            <div class="col-md">: {{ getDimension(rfqData.dimension) }}</div>
          </div> -->
        </div>
      </template>
      <template v-else>
        <div class="col-md _infoheader__middle">
          <div class="row">
            <div class="col-md-6 pr-0">Shipment Date</div>
            <div class="col-md">: {{ getDate(rfqData.tms_departure_time) }}</div>
          </div>
          <div class="row">
            <div class="col-md-6 pr-0">Fleet Category</div>
            <div class="col-md">: {{ rfqData.tms_fleet_category }}</div>
          </div><div class="row">
            <div class="col-md-6 pr-0">Fleet Type</div>
            <div class="col-md">: {{ rfqData.tms_fleet_type }}</div>
          </div>
        </div>
      </template>
      <div v-if="rfqData.service_head !== 'LAND'" class="col-md _infoheader__right">
        <div class="row" v-if="rfqData.shipment_type !== 'BARGE'
                && rfqData.shipment_type !== 'LCT'">
          <div class="col">Product Type</div>
          <div class="col">: {{ getProductType(rfqData.product_class) }}</div>
        </div>
        <div class="row">
          <div class="col">Commodities</div>
          <div class="col" v-if="rfqData.shipment_type === 'BARGE'
                || rfqData.shipment_type === 'LCT'">: {{ rfqData.product_type }}</div>
          <div class="col" v-else>: {{ rfqData.description }}</div>
        </div>
        <div class="row">
          <div class="col">Insurance</div>
          <div class="col">: {{ rfqData.m_insurance.name }}</div>
        </div>
        <div class="row" v-if="rfqData.product_class === 'DG' && rfqData.un_number">
          <div class="col">UN Number</div>
          <div class="col">: {{ rfqData.un_number }}</div>
        </div>
        <div class="row">
          <div class="col">HS Code</div>
          <div class="col">: {{ rfqData.hs_code || '-' }}</div>
        </div>
        <div class="row">
          <div class="col">PO Number</div>
          <div class="col">: {{ rfqData.po_number ? mixinConvertSymbol(rfqData.po_number, '&') : '-'}}</div>
        </div>
         <div class="row">
          <div class="col">Shipment Service</div>
          <div class="col">: {{ getOptionTp(rfqData.optiontp) }}</div>
        </div>
        <!--  -->
        <div class="_infoheader__rightCol--card">
          <b-card no-body class="mb-1">
            <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <div class="row">
                  <div class="col-md">Origin Country</div>
                  <div class="col">: {{ rfqData.countryf }}</div>
                </div>
                <!-- <div class="row" v-if="rfqData.shipment_type && rfqData.shipment_type.includes('FCL') && rfqData.weight_estimation">
                  <div class="col-md pr-0 mr-3">Weight per Container</div>
                  <div class="col-md">: {{ JSON.parse(rfqData.packing_list)[0].weight }} Kg</div>
                </div>
                <div class="row" v-if="(rfqData.shipment_type === 'AIRCARGO' || rfqData.shipment_type === 'AIRCOURIER' || rfqData.shipment_type === 'SEALCL')">
                  <div class="col-md r-0">{{ `Weight per ${JSON.parse(rfqData.packing_list)[0].satuan}`}}</div>
                  <div class="col-md">: {{ rfqData ? rfqData.shipment_type === 'AIRCOURIER' ? parseFloat(rfqData.estimatedweight).toFixed(1) : rfqData.estimatedweight : 0 }} Kg</div>
                </div> -->
                <div class="row">
                  <div class="col-md">Origin City</div>
                  <div class="col">: {{ rfqData.cityf }}</div>
                </div>
                <div class="row" v-if="rfqData.optiontp === 'dtp' || rfqData.optiontp === 'dtd'">
                  <div class="col-md">Pickup Address</div>
                  <div class="col">: {{ rfqData.pickup_address || '-' }}</div>
                </div>
                <div class="row" v-if="rfqData.shipment_type === 'BARGE' || rfqData.shipment_type === 'LCT'">
                  <div class="col-md">Origin Address or Jetty Coordinate Point</div>
                  <div class="col">: {{ rfqData.pickup_address || '-' }}</div>
                </div>
                <div class="row">
                  <div class="col-md">Destination Country</div>
                  <div class="col">: {{ rfqData.countryt}}</div>
                </div>
                <div class="row">
                  <div class="col-md">Destination City</div>
                  <div class="col">: {{ rfqData.cityt}}</div>
                </div>
                <div class="row" v-if="rfqData.optiontp === 'ptd' || rfqData.optiontp === 'dtd'">
                  <div class="col-md">Delivery Address</div>
                  <div class="col">: {{ rfqData.delivery_address || '-' }}</div>
                </div>
                <div class="row" v-if="rfqData.shipment_type === 'BARGE' || rfqData.shipment_type === 'LCT'">
                  <div class="col-md">Destination Address or Jetty Coordinate Point</div>
                  <div class="col">: {{ rfqData.delivery_address || '-' }}</div>
                </div>
                <!-- <div class="row">
                  <div class="col-md">Additional Options</div>
                  <div class="col">
                    :  {{getAdditional(rfqData.option_customs_clearance, rfqData.option_customs_clearance_destination, rfqData.option_estimate_storage) || '-'}}
                  </div>
                </div> -->
                <div class="row">
                  <div class="col-md">Remarks</div>
                  <div class="col">: {{ rfqData.note_for_merchant ? rfqData.note_for_merchant : '-' }}</div>
                </div>
              </b-card-body>
            </b-collapse>
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button class="col justify-content-end _infoheader__rightCol--showhide" href="#" v-b-toggle.accordion2>Show More</b-button>
            </b-card-header>
          </b-card>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import mixinFunctions from '@/mixin/getters/functions'
import mixin from '@/mixin/manage-shipment/tab_list'

export default {
  name: 'InfoHeader',
  props: {
    statusBid: String
  },
  components: {
    HalfCircleSpinner
  },
  mixins: [mixinFunctions, mixin],
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      rfqData: 'rfq/item',
      isLoading: 'rfq/isLoading',
      isError: 'rfq/error'
    })
  },
  methods: {
    getProductType (item) {
      if (item === 'GENCO') {
        return 'General Cargo'
      }
      if (item === 'SC') {
        return 'Special Cargo'
      }
      if (item === 'DG') {
        return 'Dangerous Goods'
      }
    },
    getContainerOption (data) {
      if (data === 'SOC') { return `Shipper's Own Container (SOC)` } else if (data === 'COC') { return `Carrier's Owned Container (COC)` } else { return '-' }
    },
    getDimension (dimension) {
      if (dimension) {
        const newdimension = JSON.parse(dimension)
        return (`${newdimension.length ? newdimension.length : '0'}x${newdimension.width ? newdimension.width : '0'}x${newdimension.height ? newdimension.height : '0'} cm`)
      }
    },
    goBack () {
      localStorage.removeItem('bookingForm')
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    },
    getAdditional (insurance, customsClearance, clearanceDestination, dangerousGoods, estimateStorage) {
      let additional = []
      if (customsClearance === 'true') { additional.push('Custom Clearance (Origin)') }
      if (clearanceDestination === 'true') { additional.push('Custom Clearance (Destination)') }
      if (estimateStorage === 'true') { additional.push('Estimate Storage') }
      return (additional.length > 0 ? additional.join(',\n') : '-')
    },
    getFreigtMode (mode) {
      if (mode === 'OCEAN') { return 'Ocean' }
      if (mode === 'AIR') { return 'Air' }
      if (mode === 'LAND') { return 'Land' }
    },
    getShipmentType (type) {
      if (type === 'AIRCARGO') {
        const newType = type.replace('AIRCARGO', 'Air Cargo')
        return newType
      } else if (type === 'AIRCOURIER') {
        const newType = type.replace('AIRCOURIER', 'Air Courier')
        return newType
      } else {
        if (type !== 'LCL') { return type } else { return 'LCL' }
      }
    },
    getDate (date) {
      return moment(date).format('DD MMM YYYY')
    },
    getOptionTp (type) {
      let optionTp = '-'
      switch (type) {
        case 'ptp' : optionTp = 'Port to Port'
          break
        case 'dtp' : optionTp = 'Door to Port'
          break
        case 'dtd' : optionTp = 'Door to Door'
          break
        case 'ptd' : optionTp = 'Port to Door'
          break
        default : optionTp = '-'
        /* eslint-disable-next-line */
      }
      /* eslint-disable-next-line */
      return optionTp
      /* eslint-disable-next-line */
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/requestStatusRFQ/InfoHeader.vue